import { Component, Injector } from '@angular/core';
import { FormComponent } from './form.component';
import { PageLayoutDataService } from '../../angular-common/page-layout-data.service';

/**
 * Per i form che occupano l'intera page
 */
@Component({ template: '' })
export abstract class PageFormComponent extends FormComponent {

  constructor(protected _injector: Injector) {
    super(_injector);
    window.scroll(0, 0);
  }

  /** @override */
  async init() {
    console.log('PageFormComponent ngOnInit()');
    await super.init()
  }

  /** @override */
  async setDatasource() {
    console.log('!!!! PageFormComponent.setDatasource')    
    await super.setDatasource();
    this._injector.get(PageLayoutDataService).loading = false;
  }
}
